import { render } from "./HowItWorksComponent.vue?vue&type=template&id=6366d806"
import script from "./HowItWorksComponent.vue?vue&type=script&lang=js"
export * from "./HowItWorksComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__